/**
 * "Próximamente" content: the next courses in the course plan (v2, 2026-10-29),
 * in launch order. The landing has its own copy in `approvedLanding.upcoming`
 * (apps/landing/src/data/site.ts); keep both in sync.
 */
export interface UpcomingCourse {
  slug: string;
  category: string;
  route: string;
  title: string;
  outcome: string;
  accent: "bubble" | "lemon" | "grape" | "paper";
  photo: string;
}

export const upcoming = {
  eyebrow: "Lo que viene",
  title: "Próximamente",
  note: "Más ideas para lo que viene.",
  description: "Estos cursos todavía no están disponibles para comprar.",
  status: "Próximamente",
  courses: [
    {
      slug: "creacion-de-contenido-con-ia",
      category: "Creación de contenido",
      route: "02",
      title: "Creación de contenido con IA",
      outcome:
        "Terminas con un mes de contenido listo para tu marca: posts, carruseles y videos cortos.",
      accent: "bubble",
      photo: "/cursos/creacion-de-contenido-con-ia.webp",
    },
    {
      slug: "automatiza-con-agentes",
      category: "Automatización",
      route: "03",
      title: "Automatiza tu trabajo con agentes de IA",
      outcome:
        "Terminas con una automatización real funcionando en tu trabajo.",
      accent: "grape",
      photo: "/cursos/automatiza-con-agentes.webp",
    },
    {
      slug: "apps-moviles-con-ia",
      category: "Apps móviles",
      route: "04",
      title: "Apps móviles con IA",
      outcome: "Terminas con tu propia app funcionando en tu celular.",
      accent: "paper",
      photo: "/cursos/apps-moviles-con-ia.webp",
    },
  ] satisfies UpcomingCourse[],
};
